var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"installed-list-callback"},[_c('BasePage',_vm._g(_vm._b({attrs:{"list":_vm.sortedList}},'BasePage',_vm.config,false),_vm.listeners)),(_vm.isAllCallbacked)?_c('div',{staticClass:"full-callback-message"},[_c('div',{staticClass:"message-content"},[_vm._v("已全量回传安装列表")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }